/* eslint-disable no-undef */
/* eslint-disable import/prefer-default-export */

export const deliveries = ({ prepaid, dvp }) => {
  let deliveriesHtml = '';

  const generateList = (list) => `
    <div class="shipping__list">
      ${list.map((shipping) => `
        <div class="shipping__element">
          <div class="shipping__logo">
            <img src="${shipping.icon}" />
          </div>
          <div class="shipping__details">
            <div class="shipping__name">${shipping.name}</div>
            <div class="shipping__time"></div>
          </div>
          <div class="shipping__cost">
            ${shipping.cost === '0.00' ? 'Gratis!' : shipping.cost_formatted}
          </div>
        </div>
      `).join('')}
    </div>
  `;

  if (prepaid && prepaid.length) {
    deliveriesHtml += `
      <section class="shipping__prepaid">
        <div class="headline --small">${Literals.projectorShipping.prepaidTitle}</div>
        ${generateList(prepaid)}
      </section>
    `;
  }

  if (dvp && dvp.length) {
    deliveriesHtml += `
      <section class="shipping__dvp">
        <div class="headline --small">${Literals.projectorShipping.dvpTitle}</div>
        ${generateList(dvp)}
      </section>
    `;
  }

  return `<section class="shipping__modal">${deliveriesHtml}</section>`;
};
